import React, { useEffect, useState } from "react";
import {
  formatedAddress,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { getAssetPopupDetail } from "./AssetHelper";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import DetailPhotoBody from "../../components/DetailPhotoBody";
import HtmlContent from "../../components/HTMLContent";
import { useOrganization } from "../../lib/context/OrganisationContext";

const AssetDetailsPopup = ({ assetId, showView, setShowView }) => {
  const { organizationData } = useOrganization();
  const [assetDetail, setAssetDetail] = useState(null);
  const [assetLoading, setAssetLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const assetDetailData = await getAssetPopupDetail(assetId, true);
      setAssetDetail(assetDetailData);
      setAssetLoading(false);
    }
    fetchData();
  }, [assetId, setAssetDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={`${getModuleNamingBySlug(
        organizationData?.organizationData,
        "assets",
        "Asset"
      )} Details`}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {assetLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          {assetDetail?.photo && (
            <DetailPhotoBody
              textValue={assetDetail?.name?.charAt(0)}
              imgURL={assetDetail?.photo}
              profileName={assetDetail?.name ? assetDetail?.name : ""}
            />
          )}
          <div className="modal-content">
            <CardTitle className="text-md mb-2">
              {getModuleNamingBySlug(
                organizationData?.organizationData,
                "assets",
                "Asset"
              )}{" "}
              Details
            </CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>Code:</strong>{" "}
                {assetDetail?.code ? assetDetail?.code : "-"}
              </p>
              <p>
                <strong>Name:</strong>{" "}
                {assetDetail?.name ? assetDetail?.name : "-"}
              </p>
              <p>
                <strong>Estimated/Reserved Value:</strong>{" "}
                {assetDetail?.estimated_value
                  ? "$" + formatNumber(Number(assetDetail?.estimated_value))
                  : "$0.00"}
              </p>
              <p>
                <strong>
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "vendors",
                    "Vendor"
                  )}
                  :
                </strong>{" "}
                {assetDetail?.vendor
                  ? formatSubcontractorName(assetDetail?.vendor)
                  : "-"}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Address:</strong>{" "}
                {formatedAddress(
                  assetDetail?.street,
                  assetDetail?.suburb?.name,
                  assetDetail?.state?.name,
                  assetDetail?.postal_code
                )}
              </p>
            </div>
          </div>
          {assetDetail?.sub_asset && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                {getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "sub-assets",
                  "Sub Asset"
                )}{" "}
                Details
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Name:</strong>{" "}
                  {assetDetail?.sub_asset?.name
                    ? assetDetail?.sub_asset?.name
                    : "-"}
                </p>
                <p>
                  <strong>Identifier:</strong>{" "}
                  {assetDetail?.sub_asset?.identifier
                    ? assetDetail?.sub_asset?.identifier
                    : "-"}
                </p>
                <p>
                  <strong>Estimated/Reserved Value:</strong>{" "}
                  {assetDetail?.sub_asset?.estimated_value
                    ? "$" +
                      formatNumber(
                        Number(assetDetail?.sub_asset?.estimated_value)
                      )
                    : "$0.00"}
                </p>
                <p className="flex gap-1">
                  <strong className="whitespace-nowrap">Description:</strong>{" "}
                  <HtmlContent
                    html={
                      assetDetail?.sub_asset?.description
                        ? assetDetail?.sub_asset?.description
                        : ""
                    }
                  />
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default AssetDetailsPopup;
